export default [
  {
    description: 'Painel do Estudante',
    path: '/publicas/estudantes/painelestudante',
    name: 'painelestudante',
    component: () => import('@/views/publicas/estudantes/painelestudante.vue'),
    meta: {
      isLegacy: true
    },
    goesToMenu: true,
  },
  {
    description: 'Carteirinha do Estudante',
    path: '/publicas/estudantes/carteirinha',
    name: 'carteirinhaestudante',
    component: () => import('@/views/publicas/estudantes/carteirinha.vue'),
    meta: {
      isLegacy: true
    },
    goesToMenu: true,
  },
]

